import React, { memo, useMemo } from 'react';

import Box from '@material-ui/core/Box';
import formatPrice from 'services/helpers/formatPrice';
import { pluralize } from 'services/helpers/formatters';

const PURCHASE_TYPES = ['PURCHASE', 'ADMIN_PURCHASE', 'PURCHASE_ADJUSTMENT'];

const InitialBalanceField = (props) => {
  const { record } = props;

  const isNegativeRefund = useMemo(() => {
    if (!record.type.includes('REFUND')) {
      return false;
    }

    const recordCurrency = Object.keys(record?.amounts).filter(
      (currency) => currency !== 'LABEL'
    )[0];

    const refundAmount = record.amounts?.[recordCurrency];
    return Boolean(refundAmount && refundAmount < 0);
  }, [record.amounts, record.type]);

  const balancesString = useMemo(() => {
    const balances = record?.transactions?.map((transaction) => {
      const initial = Number(transaction?.initialBalance?.amount);
      const amount = Number(transaction?.amount?.amount);
      const currency = transaction.amount.currency;

      const resultAmount =
        PURCHASE_TYPES.includes(record.type) || isNegativeRefund
          ? initial - amount
          : initial + amount;

      return { amount: resultAmount, currency };
    });

    if (!balances?.length) {
      return '-';
    }

    let result: string[] = [];

    const currencyBalances = balances.filter((item) => item.currency !== 'LABEL');

    if (currencyBalances?.length) {
      const lastTransactionAmount = PURCHASE_TYPES.includes(record.type)
        ? Math.min(...currencyBalances.map((item) => item.amount))
        : Math.max(...currencyBalances.map((item) => item.amount));

      const lastTransaction = currencyBalances.find(
        (item) => item.amount === lastTransactionAmount
      );
      result.push(formatPrice(lastTransactionAmount, { currency: lastTransaction?.currency }));
    }

    const labelBalance = balances.filter((item) => item.currency === 'LABEL');

    if (labelBalance?.length) {
      const { amount } = labelBalance[0];

      result.push(pluralize(amount, 'label'));
    }

    return result?.join(', ');
  }, [isNegativeRefund, record?.transactions, record.type]);

  return <Box>{balancesString}</Box>;
};

export default memo(InitialBalanceField);
